import React from 'react'
import ProdIOORetAddRow from './ProdIOORetAddRow'
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormDialog from '../../../../../library/form/components/FormDialog';
import { UiView, UiViewContent } from "../../../../../library/layout/Index";

const ProdIOORetAdd = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel", confirmAction:"Are you sure to Confirm ?", confirmCancel:"Are you sure to Cancel ?" }, actionParam: {actionType:"returnOutput", pathKey:"ORET"} }}
            formStyle={{ width: '650px', height: '450px' }}
            contentStyle={{ height: '300px' }}
            formTitle={<SarasTrans value='Return Material to Stock' />}
            >
            <UiView>
                <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn30"><SarasTrans value="Sr No." /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Item Name" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Available Quantity" /></li>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Return Quantity" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                <li><ProdIOORetAddRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1} /></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
            </FormDialog>
    )
}

export default withView(ProdIOORetAdd, "prodIOAddORET", "prodIOSum");
